import { render, staticRenderFns } from "./TermMain.vue?vue&type=template&id=22784a4b&scoped=true&"
import script from "./TermMain.vue?vue&type=script&lang=js&"
export * from "./TermMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22784a4b",
  null
  
)

export default component.exports